import { makeStyles } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    textAlign: 'right',
    '& img': {
      maxHeight: '100%',
      width: 120,
    },
    height: '100%',
  },
}))

const StripeLogo: React.FC<{}> = (props) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <img alt="Logo" src="/static/poweredbystripe.svg" {...props} />
    </div>
  )
}

export default StripeLogo
